import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Skeleton, Box } from '@mui/material';
import { useSelector } from 'react-redux';
import Typography from 'components/Atoms/Typography';
import useToast from 'components/Provider/useToast';
import downloadFile from 'utils/downloadFile';
import OnboardingRecord from 'components/Templates/Profile/OnboardingRecord';
import useFetchRecord from './useFetchRecord';
import { modifyViewData } from './modifyViewData';

const ViewOnboardingRecord = () => {
  const [employee, fetchEmployee] = useFetchRecord();
  const navigate = useNavigate();
  const addToast = useToast();

  useEffect(() => {
    fetchEmployee();
  }, []);

  const { user } = useSelector((state) => {
    return state.session;
  });

  if (employee.error !== null) {
    return (
      <Typography variant="h6">
        {employee?.error?.response?.data?.message || 'Error while loading onboarding record details.'}
      </Typography>
    );
  }
  const transformedData = modifyViewData(employee, user);

  const handleAttachment = async (docid, filename) => {
    try {
      downloadFile({ docid }, filename, 'restPayIndex/downloadAttachment');
      addToast({
        type: 'success',
        title: 'SUCCESS',
        message: `Attachment downloaded successfully`,
      });
    } catch (err) {
      addToast({
        type: 'error',
        title: 'ERROR',
        message: err.message || `Failed to download attachment`,
      });
    }
  };

  return employee?.isLoading ? (
    <Box sx={{ p: 4 }}>
      <Skeleton height={70} />
      <Skeleton />
      <Skeleton />
    </Box>
  ) : (
    <OnboardingRecord
      onboardingForm={transformedData}
      cardDetails={transformedData?.cardDetails}
      attachmentData={transformedData?.attachmentData}
      handleEdit={() => navigate('/profile/onboardingrecords/edit')}
      handleAttachment={handleAttachment}
    />
  );
};

export default ViewOnboardingRecord;
